<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Pricing Form</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <b-row>
              <!-- {{enquiryArry}} -->
              <b-col class="col-md-6 col-sm-6">
                <span class="error">
                  Enq. No: {{ enquiryArry.enq_no }}
                  <b>({{ enquiryArry.is_enq_closed == "0" ? "Running" : "Closed" }})<br /></b>
                  Note : Prefered
                  <!-- {{ enquiryArry.shipment_type }} -->
                  {{ enquiryArry.shipment_type == "Sea" ? "Shipping Line" : "Air Line" }}
                  :
                  <b>{{
                    enquiryArry.shipment_type == "Sea"
                    ? enquiryArry.prefredShippingLine
                    : enquiryArry.airlineName
                    }}</b>
                </span>
              </b-col>
              <b-col class="col-md-6 col-sm-6 mt-2 text-right">
                <b-button v-if="enquiryArry.is_enq_closed == 0" size="sm" class="text-right mt-2"
                  style="margin:left:5px" variant="primary" @click="ClearPricingDetails('clearAll')">Add Another
                  Shipping Line</b-button>
              </b-col>

              <b-col class="col-md-3" v-if="enquiryArry.shipment_type == 'Air'">
                <label>Air Line (Prefered)<span class="error">*</span></label>
                <!-- :isDisabled="pricingForm.fk_airline_id ? true : false" -->
                <model-list-select :isDisabled="pricingForm.fk_airline_id ? true : false"
                  :list="$store.getters['common/getAllAirLineList']" v-model="pricingForm.fk_airline_id"
                  option-value="airlineId" option-text="airlineName" placeholder="Select Air Line"></model-list-select>
                <span class="error" v-if="!pricingForm.fk_airline_id">
                  {{ errorList.fk_airline_id }}
                </span>
              </b-col>
              <b-col class="col-md-3" v-if="enquiryArry.shipment_type == 'Sea'">
                <label>Shipping Line (Prefered)<span class="error">*</span></label>
                <!-- :isDisabled="pricingForm.fk_shipping_id ? true : false" -->
                <model-list-select :isDisabled="pricingForm.fk_shipping_id ? true : false"
                  :list="$store.getters['common/getAllShippingLineList']" v-model="pricingForm.fk_shipping_id"
                  option-value="shippingId" option-text="shippingLine"
                  placeholder="Select Shipping Line"></model-list-select>
                <span class="error" v-if="!pricingForm.fk_shipping_id">
                  {{ errorList.fk_shipping_id }}
                </span>
              </b-col>

              <!-- Enquiry Price Engine Section Start -->
              <b-col class="col-md-3" v-if="enquiryArry.shipment_type == 'Sea'">
                <label>POL </label>
                <model-list-select :isDisabled="
                    $sessionsStorage.get('designation') != 'Admin' &&
                    $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                    pricingForm.fk_enq_price_id
                      ? true
                      : false
                  " @input="getSlinePriceEngineData()" :list="
                  enquiryArry.transport_type == 'CRC'?$store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                        ]:
                    enquiryArry.transport_type == 'Export'
                      ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
                        ]
                      : $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPOLDDList'
                        ]
                  " v-model="pricingForm.fk_pol_id" option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select POL"></model-list-select>
              </b-col>

              <!-- $store.getters['enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'] -->
              <b-col class="col-md-3" v-if="enquiryArry.shipment_type == 'Sea'">
                <label>POD</label>

                <model-list-select v-if="enquiryArry.transport_type == 'Import' || enquiryArry.transport_type == 'CRC'" :isDisabled="
                    $sessionsStorage.get('designation') != 'Admin' &&
                    $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                    pricingForm.fk_enq_price_id
                      ? true
                      : false
                  " @input="
                    getLocationList(
                      $event,
                      enquiryArry.shipment_type == 'Sea' &&
                        enquiryArry.transport_type == 'Export'
                        ? 'Sea_Port_NonIndia'
                        : 'Sea_Port_India',
                      'getPortDischargeList'
                    )
                  " @searchchange="
                    getLocationList(
                      $event,
                      enquiryArry.shipment_type == 'Sea' &&
                        enquiryArry.transport_type == 'Export'
                        ? 'Sea_Port_NonIndia'
                        : 'Icd,Sea_Port_India',
                      'getPortDischargeList'
                    )
                  " :list="enquiryArry.transport_type == 'CRC'?$store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
                        ]:
                    enquiryArry.shipment_type == 'Sea' &&
                    enquiryArry.transport_type == 'Export'
                      ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
                        ]
                      : $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPODDDList'
                        ].length > 0
                      ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPODDDList'
                        ]
                      : getPortDischargeList.length > 0
                      ? getPortDischargeList
                      : $store.getters['common/getAllLocationDetailsFinalList']
                  " v-model="pricingForm.fk_pod_id" option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select POD"></model-list-select>
                <model-list-select v-if="enquiryArry.transport_type == 'Export'" :isDisabled="
                    $sessionsStorage.get('designation') != 'Admin' &&
                    $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                    pricingForm.fk_enq_price_id
                      ? true
                      : false
                  " @input="getSlinePriceEngineData()" :list="
                    enquiryArry.transport_type == 'Export'
                      ? $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
                        ]
                      : $store.getters[
                          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPODDDList'
                        ]
                  " v-model="pricingForm.fk_pod_id" option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select POD"></model-list-select>
              </b-col>
              <b-col md="3" v-if="enquiryArry.shipment_type == 'Sea'">
                <label>
                  Commodity Type
                  <span class="error"></span>
                </label>
                <model-list-select :isDisabled="
                    $sessionsStorage.get('designation') != 'Admin' &&
                    $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                    pricingForm.fk_enq_price_id
                      ? true
                      : false
                  " :list="commodityTypeName" id="commodity_type" v-model="pricingForm.commodity_type"
                  option-value="commodityTypeVal" option-text="commodityTypeText"
                  placeholder="Please Select commodity Type" @input="getSlinePriceEngineData()"></model-list-select>
                <span class="error" v-if="!pricingForm.commodity_type">
                  {{ errorList.commodity_type }}
                </span>
              </b-col>
              <!-- Enquiry Price Engine Section End -->

              <b-col class="col-md-3 col-sm-6">
                <label>Rate Validity Date<span class="error">*</span></label><br />
                <date-picker lang="en" :format="selectDateFormat" id="validityDate" name="validityDate"
                  v-model="pricingForm.validityDate"></date-picker>
                <span class="error" v-if="!pricingForm.validityDate">
                  {{ errorList.validityDate }}
                </span>
              </b-col>
              <b-col class="col-md-3 col-sm-6" v-if="enquiryArry.shipment_type == 'Sea'">
                <label>Rate Validity Till<span class="error">*</span></label>
                <model-list-select :list="qTillList" v-model="pricingForm.quotationTill" option-value="qV"
                  option-text="qT" placeholder="Select"></model-list-select>
                <span class="error" v-if="!pricingForm.quotationTill">
                  {{ errorList.quotationTill }}
                </span>
              </b-col>

              <b-col class="col-md-3 col-sm-6">
                <label>Transit Time (No.of Days)<span class="error"></span></label>
                <b-form-input :formatter="capitalizeAll" id="transitTime" name="transitTime" type="number"
                  v-model="pricingForm.transitTime"></b-form-input>
                <span class="error" v-if="!pricingForm.transitTime">
                  {{ errorList.transitTime }}
                </span>
              </b-col>
              <b-col class="col-md-3 col-sm-6" v-if="enquiryArry.shipment_type == 'Sea'">
                <label>Container Type</label>
                <model-list-select :list="
                    EnqContainerTypeList.length > 0
                      ? EnqContainerTypeList
                      : $store.getters['common/getAllContainerTypeList']
                  " v-model="pricingForm.fk_container_type_id" option-value="containerTypeId"
                  option-text="containerType" placeholder="Select Container Type"></model-list-select>
                <span class="error" v-if="!pricingForm.fk_container_type_id">
                  {{ errorList.fk_container_type_id }}
                </span>
              </b-col>
              <b-col class="col-md-3 col-sm-6">
                <label>Particular Types<span class="error">*</span></label>
                <model-list-select :list="ParticularTypeList" v-model="pricingForm.ParticularType" option-value="PTV"
                  option-text="PTT" placeholder="Select Particular Types"></model-list-select>
                <span class="error" v-if="!pricingForm.ParticularType">
                  {{ errorList.ParticularType }}
                </span>
              </b-col>
              <b-col class="col-md-3 col-sm-6">
                <label>Particular<span class="error">*</span></label>
                <model-list-select :list="$store.getters['common/getAllLedgerList']" v-model="pricingForm.fk_ledger_id"
                  option-value="ledgerId" option-text="ledger" placeholder="Select Particular"></model-list-select>
                <span class="error" v-if="!pricingForm.fk_ledger_id">
                  {{ errorList.fk_ledger_id }}
                </span>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="col-md-3 col-sm-6" v-if="enquiryArry.shipment_type == 'Air'">
                <label for="noOfPkg">No. of Packages</label>
                <b-form-input :formatter="capitalizeAll" id="noOfPkg" name="noOfPkg" type="number"
                  v-model="pricingForm.noOfPkg"></b-form-input>
              </b-col>
              <b-col class="col-md-3 col-sm-6" v-if="enquiryArry.shipment_type == 'Air'">
                <label for="lclGrossWgt">Gross Wgt(Kg)</label>
                <b-form-input :formatter="capitalizeAll" id="lclGrossWgt" name="lclGrossWgt" type="number"
                  v-model="pricingForm.lclGrossWgt"></b-form-input>
              </b-col>
              <b-col class="col-md-3 col-sm-6" v-if="enquiryArry.shipment_type == 'Air'">
                <label for="lclNetWgt">Net Wt ( in KG)</label>
                <b-form-input :formatter="capitalizeAll" id="lclNetWgt" name="lclNetWgt" type="number"
                  v-model="pricingForm.lclNetWgt"></b-form-input>
              </b-col>
              <!-- <b-col class="col-md-3 col-sm-6" v-if="enquiryArry.shipment_type == 'Air'">
                <label for="cargoReceived">Cargo Received At</label>
                <model-list-select
                  :list="cargoReceivedList"
                  v-model="pricingForm.cargoReceived"
                  option-value="val"
                  option-text="type"
                  placeholder="Select Cargo Received"
                ></model-list-select>
              </b-col> -->

              <b-col class="col-md-3 col-sm-6">
                <label for="buyingRate">Buying Rate</label>
                <b-form-input :formatter="capitalizeAll" id="buyingRate" name="buyingRate" type="number"
                  placeholder="Please Enter Buying Rate" v-model="pricingForm.buyingRate"></b-form-input>
              </b-col>
              <!-- <b-col class="col-md-3 col-sm-6">
                <label for="sellingRate">Selling Rate</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="sellingRate"
                  name="sellingRate"
                  type="number"
                  placeholder="Please Enter Selling Rate"
                  v-model="pricingForm.sellingRate"
                ></b-form-input>
              </b-col> -->
              <b-col class="col-md-3 col-sm-6">
                <label for="Currency">Currency</label>
                <model-list-select :list="$store.getters['common/getAllCurrencyList']"
                  v-model="pricingForm.fk_currency_id" option-value="currency_id" option-text="currencyCode"
                  placeholder="Select Currency"></model-list-select>
              </b-col>
              <b-col class="col-md-3 col-sm-6">
                <label for="Units">Units</label>
                <model-list-select :list="$store.getters['common/getAllUnitList']" v-model="pricingForm.fk_unit_id"
                  option-value="unitId" option-text="unitName" placeholder="Select Units"></model-list-select>
              </b-col>
              <!-- <b-col class="col-md-3 col-sm-6">
                <label for="Currency">Terms</label>
                <model-list-select
                  :list="termList"
                  v-model="pricingForm.terms"
                  option-value="tV"
                  option-text="tT"
                  placeholder="Select Terms"
                ></model-list-select>
              </b-col> -->
              <b-col md="3">
                <label>
                  Transhipment
                  <!-- {{pricingForm.transhipment}} -->
                  <span class="error">*</span>
                </label>
                <b-form-radio-group v-model="pricingForm.transhipment" :options="transhipmentList" class="mb-3"
                  value-field="payVal" text-field="payText" disabled-field="notEnabled"
                  @input="TranshipmentVal()"></b-form-radio-group>
                <span class="error" v-if="!pricingForm.transhipment">
                  {{ errorList.transhipment }}
                </span>
              </b-col>
              <b-col class="col-md-3" v-if="
                  enquiryArry.shipment_type == 'Sea' && pricingForm.transhipment == 'Yes'
                ">
                <label>Transhipment</label>
                <model-list-select @input="getLocationList($event, 'All', 'getPortDischargeList')"
                  @searchchange="getLocationList($event, 'All', 'getPortDischargeList')" :list="
                    getPortDischargeList.length > 0
                      ? getPortDischargeList
                      : $store.getters['common/getAllLocationDetailsFinalList']
                  " v-model="pricingForm.fk_pod_id" option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select POD"></model-list-select>
              </b-col>
              <b-col class="col-md-3" v-if="
                  enquiryArry.shipment_type == 'Air' && pricingForm.transhipment == 'Yes'
                ">
                <label>Airport of Destination</label>
                <model-list-select @input="getLocationList($event, 'All', 'AirPortLoadList')"
                  @searchchange="getLocationList($event, 'All', 'AirPortLoadList')"
                  :list="$store.getters['common/getAllAirPortDestinationList']"
                  v-model="pricingForm.fk_airportDestination_id" option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select Airport of Destination"></model-list-select>
              </b-col>
              <b-col class="col-md-3 col-sm-6" v-if="enquiryArry.shipment_type == 'Sea'">
                <label for="quoRate">Pricing Remarks</label>
                <b-textarea :formatter="capitalizeAll" id="quoRate" name="quoRate"
                  v-model="pricingForm.quotation_remark"></b-textarea>

                <!-- rows="5" -->
              </b-col>

              <!-- Enquiry Price Engine Start -->
              <b-col md="12" v-if="
                  ((pricingForm.fk_enq_price_id &&
                    pricingForm.fk_shipping_id &&
                    pricingForm.fk_pod_id &&
                    pricingForm.fk_pol_id &&
                    pricingForm.commodity_type) ||
                    (pricingForm.priceengine_json !== null &&
                      pricingForm.price_id &&
                      pricingForm.priceengine_json.length > 0)) &&
                  PricingEngineCountArr.length > 0
                ">
                <table class="table table-sm table-bordered mt-2">
                  <tbody style="background: white">
                    <tr v-if="PricingEngineCountArr.length > 0">
                      <th scope="col" style="width: 5px">SN.</th>
                      <th scope="col" style="width: 200px">Commodity</th>
                      <!-- <th scope="col" style="width: 200px">POR</th> -->
                      <th scope="col" style="width: 200px">POL</th>
                      <th scope="col" style="width: 200px">POD</th>
                      <!-- <th scope="col" style="width: 200px">FPOD</th> -->
                      <th scope="col" style="width: 200px">Container Type</th>
                      <th scope="col" style="width: 200px">Currency</th>
                      <th scope="col" style="width: 200px">AMT</th>
                      <th scope="col" style="width: 180px">Additional Charges AMT</th>
                      <th scope="col" style="width: 180px">Total AMT</th>
                      <!-- <th scope="col" style="width: 180px">OF-40 HC</th>
                      <th scope="col" style="width: 180px">Additional Charges-40 HC</th>
                      <th scope="col" style="width: 180px">Total 40 HC</th> -->
                      <th scope="col" style="width: 180px">Free Time</th>
                      <th scope="col" style="width: 180px">Validity Date</th>
                      <th scope="col" style="width: 180px">Handover/Gate IN/Sailing</th>
                      <th scope="col" style="width: 5px">
                        Actions
                        <b-button @click="addPricingEngineCount()" size="sm">
                          <i class="fa fa-plus-circle ml-1"></i>
                        </b-button>
                      </th>
                    </tr>
                    <tr v-for="(item, index) in PricingEngineCountArr" :key="index">
                      <th scope="row">{{ index + 1 }}.</th>
                      <td>
                        <model-list-select :isDisabled="item.is_new == 2 ? true : false" :list="commodityTypeName"
                          v-model="item.commodity_type" option-value="commodityTypeVal" option-text="commodityTypeText"
                          placeholder="Select Commodity Type"></model-list-select>
                        <span class="error" v-if="item.commodity_type_err ? true : false">
                          {{ item.commodity_type_err }}
                        </span>
                      </td>
                      <!-- <td>
                        <model-list-select
                          :isDisabled="
                            $sessionsStorage.get('designation') != 'Admin' &&
                            $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                            enqPriceEngineForm.enq_price_engine_id
                              ? true
                              : false
                          "
                          @input="getLocationList($event, 'All', 'IcdPOrtList')"
                          @searchchange="getLocationList($event, 'All', 'IcdPOrtList')"
                          :list="
                            $store.getters[
                              'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
                            ]
                          "
                          v-model="item.fk_por_id"
                          option-value="pickupId"
                          option-text="pickupLocation"
                          placeholder="Select POR"
                        ></model-list-select>
                        <span class="error" v-if="item.fk_por_id_err ? true : false">{{
                          item.fk_por_id_err
                        }}</span>
                      </td> -->
                      <td>
                        <model-list-select :isDisabled="item.is_new == 2 ? true : false" :list="
                            $store.getters[
                              'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
                            ]
                          " v-model="item.fk_pol_id" option-value="pickupId" option-text="pickupLocation"
                          placeholder="Select POL"></model-list-select>
                        <span class="error" v-if="item.fk_pol_id_err ? true : false">{{
                          item.fk_pol_id_err
                          }}</span>
                      </td>
                      <td>
                        <model-list-select :isDisabled="item.is_new == 2 ? true : false" :list="
                            $store.getters[
                              'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
                            ]
                          " v-model="item.fk_pod_id" option-value="pickupId" option-text="pickupLocation"
                          placeholder="Select POD"></model-list-select>
                        <span class="error" v-if="item.fk_pod_id_err ? true : false">{{
                          item.fk_pod_id_err
                          }}</span>
                      </td>
                      <!-- <td>
                        <model-list-select
                          :isDisabled="item.is_new==2 ? true : false"
                          @input="getLocationList($event, 'All', 'getPortDischargeList')"
                          @searchchange="
                            getLocationList($event, 'All', 'getPortDischargeList')
                          "
                          :list="
                            getPortDischargeList.length > 0
                              ? getPortDischargeList
                              : $store.getters[
                                  'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
                                ]
                          "
                          v-model="item.fk_fpod_id"
                          option-value="pickupId"
                          option-text="pickupLocation"
                          placeholder="Select FPOD"
                        ></model-list-select>
                        <span class="error" v-if="item.fk_fpod_id_err ? true : false">{{
                          item.fk_fpod_id_err
                        }}</span>
                      </td> -->
                      <td>
                        <model-list-select :isDisabled="item.is_new == 2 ? true : false"
                          :list="$store.getters['common/getAllContainerTypeList']" v-model="item.fk_cont_type_id"
                          option-value="containerTypeId" option-text="containerType"
                          placeholder="Select Container Type"></model-list-select>
                        <span class="error" v-if="item.fk_cont_type_id_err ? true : false">{{ item.fk_cont_type_id_err
                          }}</span>
                      </td>
                      <td>
                        <model-list-select :isDisabled="item.is_new == 2 ? true : false"
                          :list="$store.getters['common/getAllCurrencyList']" v-model="item.fk_currency_id"
                          option-value="currency_id" option-text="currencyCode"
                          placeholder="Select Currency"></model-list-select>
                        <span class="error" v-if="item.fk_currency_id_err ? true : false">{{ item.fk_currency_id_err
                          }}</span>
                      </td>
                      <td>
                        <b-form-input :disabled="item.is_new == 2 ? true : false" :formatter="capitalizeAll"
                          v-model="item.of_twenty_gp" type="number" @input="CheckValueNumbers($event)"
                          @change="CheckValueNumbers($event)" v-on:keyup="TotalAMT(item, index)" @wheel="handleWheel"
                          placeholder="Enter OF-20"></b-form-input>
                        <span class="error" v-if="item.of_twenty_gp_err ? true : false">{{
                          item.of_twenty_gp_err
                          }}</span>
                      </td>
                      <td>
                        <b-form-input :disabled="item.is_new == 2 ? true : false" :formatter="capitalizeAll"
                          v-model="item.twenty_gp_add_charg" type="number" @input="CheckValueNumbers($event)"
                          @change="CheckValueNumbers($event)" v-on:keyup="TotalAMT(item, index)" @wheel="handleWheel"
                          placeholder="Enter Additional Charges-20"></b-form-input>
                        <span class="error" v-if="item.twenty_gp_add_charg_err ? true : false">{{
                          item.twenty_gp_add_charg_err }}</span>
                      </td>
                      <td>
                        <b-form-input :disabled="item.is_new == 2 ? true : false" :formatter="capitalizeAll"
                          v-model="item.tot_twenty_gp" type="number" @input="CheckValueNumbers($event)"
                          @change="CheckValueNumbers($event)" v-on:keyup="TotalAMT(item, index)" @wheel="handleWheel"
                          placeholder="Enter Total 20"></b-form-input>
                        <span class="error" v-if="item.tot_twenty_gp_err ? true : false">{{ item.tot_twenty_gp_err
                          }}</span>
                      </td>

                      <!-- <td>
                        <b-form-input
                          :formatter="capitalizeAll"
                          v-model="item.of_fourty_hc"
                          type="number"
                          @input="CheckValueNumbers($event)"
                          @change="CheckValueNumbers($event)"
                          v-on:keyup="TotalAMT(item, index)"
                          @wheel="handleWheel"
                          placeholder="Enter OF-40 HC"
                        ></b-form-input>
                        <span class="error" v-if="item.of_fourty_hc_err ? true : false">{{
                          item.of_fourty_hc_err
                        }}</span>
                      </td>
                      <td>
                        <b-form-input
                          :formatter="capitalizeAll"
                          v-model="item.fourty_hc_add_charg"
                          type="number"
                          @input="CheckValueNumbers($event)"
                          @change="CheckValueNumbers($event)"
                          v-on:keyup="TotalAMT(item, index)"
                          @wheel="handleWheel"
                          placeholder="Enter Additional Charges-40 HC"
                        ></b-form-input>
                        <span
                          class="error"
                          v-if="item.fourty_hc_add_charg_err ? true : false"
                          >{{ item.fourty_hc_add_charg_err }}</span
                        >
                      </td>
                      <td>
                        <b-form-input
                          :disabled="true"
                          :formatter="capitalizeAll"
                          v-model="item.tot_fourty_hc"
                          type="number"
                          @input="CheckValueNumbers($event)"
                          @change="CheckValueNumbers($event)"
                          v-on:keyup="TotalAMT(item, index)"
                          @wheel="handleWheel"
                          placeholder="Enter Total 40 HC"
                        ></b-form-input>
                        <span
                          class="error"
                          v-if="item.tot_fourty_hc_err ? true : false"
                          >{{ item.tot_fourty_hc_err }}</span
                        >
                      </td> -->

                      <td>
                        <b-form-input :disabled="item.is_new == 2 ? true : false" :formatter="capitalizeAll"
                          v-model="item.free_time" type="number" @wheel="handleWheel" min="1" max="50"
                          placeholder="Enter Free Time"></b-form-input>
                        <span class="error" v-if="item.free_time_err ? true : false">{{
                          item.free_time_err
                          }}</span>
                      </td>
                      <td>
                        <span :class="item.expire_status == 'Active' ? 'primary' : 'error'"
                          v-if="item.expire_status ? true : false">{{ item.expire_status }} Validity Date
                        </span>
                        <date-picker :disabled="
                            item.expire_status == 'Expired' || item.is_new == 1
                              ? false
                              : true
                          " style="margin-top: 8px" lang="en" :format="selectDateFormat" id="validityDate"
                          name="validityDate" placeholder="Enter Validity Date" :not-before="calculateMinDate()"
                          v-model="item.validity_date"></date-picker>
                        <b-button v-if="item.expire_status == 'Expired' && item.is_new == 2" class="smbutnWidth"
                          variant="primary" size="sm" style="font-size: 0.675rem" id="updateValidityDate" @click="
                            updateValidityDate(
                              item,
                              item.pre_validityDate,
                              item.validity_date
                            )
                          ">Extend</b-button>
                        <!-- <b-form-input
                          :disabled="
                            item.expire_status == 'Expired' || item.is_new == 1
                              ? false
                              : true
                          "
                          :formatter="capitalizeAll"
                          v-model="item.validity_date"
                          type="date"
                          placeholder="Enter Validity Date"
                          :min="calculateMinDate()"
                        ></b-form-input> -->

                        <span class="error" v-if="item.validity_date_err ? true : false">{{ item.validity_date_err
                          }}</span>
                        <span class="error" v-if="item.validity_date_expire_status_err ? true : false">{{
                          item.validity_date_expire_status_err }}</span>
                      </td>
                      <td>
                        <model-list-select :isDisabled="item.is_new == 2 ? true : false" :list="handOverList"
                          v-model="item.handover" option-value="handVal" option-text="handText"
                          placeholder="Select Type"></model-list-select>
                        <span class="error" v-if="item.handover_err ? true : false">
                          {{ item.handover_err }}
                        </span>
                        <!-- <b-form-input
                          :formatter="capitalizeAll"
                          v-model="item.handover"
                          type="text"
                          placeholder="Enter Handover/Gate IN/Sailing"
                        ></b-form-input> -->
                        <!-- <span class="error" v-if="item.handover_err ? true : false">{{
                          item.handover_err
                        }}</span> -->
                      </td>
                      <td>
                        <b-button :disabled="item.is_new == 2 ? true : false" v-if="index > 0" size="sm"
                          @click="removePricingEngineCount(index)">
                          <i class="fa fa-minus-circle" aria-hidden="true"></i>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
              <!-- Enquiry Price Engine Start -->

              <b-col class="col-md-12">
                <table class="table table-sm table-bordered mt-2">
                  <tbody style="background: white">
                    <tr v-if="CONTAINERCOUNTArr.length > 0">
                      <th scope="col" style="width: 5px">SN.</th>
                      <th scope="col" style="width: 200px">CONTAINER TYPE</th>
                      <th scope="col" style="width: 180px">Vessel</th>
                      <th scope="col" style="width: 180px">Rate Validity Date</th>
                      <th scope="col" style="width: 180px">Buying Rate Price</th>
                      <th scope="col" style="width: 5px">
                        Actions
                        <b-button @click="addContainerCount()" size="sm">
                          <i class="fa fa-plus-circle ml-1"></i>
                        </b-button>
                      </th>
                    </tr>
                    <tr v-for="(item, index) in CONTAINERCOUNTArr" :key="index">
                      <th scope="row">{{ index + 1 }}.</th>
                      <td>
                        <model-list-select :disabled="enqPrice_EditFlag"
                          :list="$store.getters['common/getAllContainerTypeList']" option-value="containerTypeId"
                          option-text="containerType" v-model="item.cont_type"
                          placeholder="Select Container Type"></model-list-select>
                        <span class="error" v-if="item.cont_type_err ? true : false">{{
                          item.cont_type_err
                          }}</span>
                      </td>
                      <td>
                        <b-form-input :disabled="enqPrice_EditFlag" :formatter="capitalizeAll" v-model="item.Vessle"
                          type="text" placeholder="Enter Vessel Name"></b-form-input>
                        <span class="error" v-if="item.Vessle_err ? true : false">{{
                          item.Vessle_err
                          }}</span>
                      </td>
                      <td>
                        <b-form-input :disabled="enqPrice_EditFlag" :formatter="capitalizeAll"
                          v-model="item.rate_validity_date" type="date"
                          placeholder="Enter Rate Validity Date"></b-form-input>
                        <span class="error" v-if="item.rate_validity_date_err ? true : false">{{
                          item.rate_validity_date_err }}</span>
                      </td>
                      <td>
                        <b-form-input :disabled="enqPrice_EditFlag" :formatter="capitalizeAll" v-model="item.buyingRate"
                          type="text" placeholder="Enter Buying Rate"></b-form-input>
                        <span class="error" v-if="item.buyingRate_err ? true : false">{{
                          item.buyingRate_err
                          }}</span>
                      </td>

                      <td>
                        <b-button v-if="index > 0" size="sm" @click="removeContainerCount(index)"
                          :disabled="enqPrice_EditFlag">
                          <i class="fa fa-minus-circle" aria-hidden="true"></i>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>

              <b-col class="col-md-12 col-sm-12 mt-2">
                <center>
                  <b-button v-if="enquiryArry.is_enq_closed == 0" size="sm" class="text-right mt-2"
                    style="margin:left:5px" variant="primary" @click="addPriceForm">Add</b-button>
                </center>
              </b-col>
              <b-col class="col-md-12 col-sm-12 mt-2" v-if="singlePricingList.length > 0">
                <div class="table-responsive tableMain">
                  <table id="ff" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>SN.</th>
                        <th v-if="enquiryArry.shipment_type == 'Sea'">Shipping Line</th>
                        <th v-else-if="enquiryArry.shipment_type == 'Air'">
                          Airline Name
                        </th>
                        <th v-if="enquiryArry.shipment_type == 'Sea'">Container Type</th>
                        <th v-if="enquiryArry.shipment_type == 'Air'">No. of Packages</th>
                        <th v-if="enquiryArry.shipment_type == 'Air'">Gross Wgt(Kg)</th>
                        <th v-if="enquiryArry.shipment_type == 'Air'">Net Wt ( in KG)</th>
                        <!-- <th v-if="enquiryArry.shipment_type == 'Air'">
                          Cargo Received At
                        </th> -->
                        <th>Particulars Type</th>
                        <th>Particulars</th>
                        <th>Rate Validity Date</th>
                        <th>Rate Validity Till</th>
                        <th>Transhipment</th>
                        <th>Via Port</th>
                        <th>Transit Time</th>
                        <th>Buying Rate</th>
                        <th>Currency</th>
                        <th>Units</th>
                        <!-- <th v-if="enquiryArry.is_enq_closed == 0">Action</th> -->
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item1, index) in singlePricingList" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td v-if="enquiryArry.shipment_type == 'Sea'">
                          {{ item1.ShippingLine }}
                        </td>
                        <td v-else-if="enquiryArry.shipment_type == 'Air'">
                          {{ item1.airlineName }}
                        </td>
                        <td v-if="enquiryArry.shipment_type == 'Sea'">
                          {{ item1.containerType }}
                        </td>
                        <td v-if="enquiryArry.shipment_type == 'Air'">
                          {{ item1.noOfPkg }}
                        </td>
                        <td v-if="enquiryArry.shipment_type == 'Air'">
                          {{ item1.lclGrossWgt }}
                        </td>
                        <td v-if="enquiryArry.shipment_type == 'Air'">
                          {{ item1.lclNetWgt }}
                        </td>
                        <!-- <td v-if="enquiryArry.shipment_type == 'Air'">
                          {{ item1.cargoReceived }}
                        </td> -->
                        <td>{{ item1.ParticularType }}</td>

                        <td>{{ item1.ledger }}</td>
                        <td>{{ item1.validityDate }}</td>
                        <td>
                          {{
                          item1.quotationTill == 1
                          ? "Validity till Handover"
                          : "Validity till Sailing"
                          }}
                        </td>
                        <td>
                          {{ item1.transhipment }}
                        </td>
                        <td>
                          {{
                          enquiryArry.shipment_type == "Sea"
                          ? item1.POD
                          : item1.ARDestination
                          }}
                        </td>

                        <td>
                          {{ item1.transitTime }}
                        </td>
                        <td>{{ item1.buyingRate }}</td>
                        <td>{{ item1.currencyCode }}</td>
                        <td>{{ item1.unitName }}</td>
                        <td v-if="item1.price_id != ''">
                          <md-button class="md-icon-button md-raised md-dense" @click="editPrice(item1, index)" v-if="enquiryArry.is_enq_closed == 0">
                            <md-icon>edit</md-icon>
                          </md-button>
                          <md-button class="md-icon-button md-raised md-dense" @click="DeletePrice(item1)">
                            <md-icon>delete</md-icon>
                          </md-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <center>
                    <b-button v-if="enquiryArry.is_enq_closed == 0" size="sm" class="text-right mt-2 mb-2"
                      style="margin:left:5px" variant="danger"
                      @click="sendCloseEnqPriceForm(singlePricingList, enquiryArry)">Send & Close</b-button>
                    <h6>
                      <span v-if="pricingForm.createdBy" class="error">Created By : {{ pricingForm.createdBy
                        }}</span><span v-if="pricingForm.created_at" class="error">
                        Created At : {{ pricingForm.created_at }}</span>
                    </h6>
                  </center>
                </div>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";

import "vue-loading-overlay/dist/vue-loading.css";

import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalGetCommodity,
} from "../../helper/collection";
import LeadService from "../../services/LeadService.js";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    // Air Section Start
    this.$store.dispatch(
      "common/setAllAirLineList",
      JSON.stringify({
        itemCode: "AirLineList",
      })
    );
    this.$store.dispatch(
      "common/setAllAirPortDepartureList",
      JSON.stringify({
        itemCode: "AirPortDepartureList",
      })
    );
    this.$store.dispatch(
      "common/setAllAirPortDestinationList",
      JSON.stringify({
        itemCode: "AirPortDestinationList",
      })
    );
    this.$store.dispatch(
        "enqPriceEngineDropdown/setAllEnqPriceEngineCrossCountryLocationDDList",
        JSON.stringify({
          itemCode: "getAllEnqPriceEngineCrossCountryDDList",
        })
      );
    // Air Section End

    // Sea Section Start
    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );

    this.$store.dispatch(
      "common/setAllPORList",
      JSON.stringify({
        itemCode: "PORList",
      })
    );
    this.$store.dispatch(
      "common/setAllPODList",
      JSON.stringify({
        itemCode: "PODList",
        type: "Normal",
        Territory: "",
      })
    );
    this.$store.dispatch(
      "common/setAllLocationDetailsFinalList",
      JSON.stringify({
        itemCode: "LocationDetailsFinalList",
      })
    );
    this.$store.dispatch(
      "common/setAllPOLList",
      JSON.stringify({
        itemCode: "POLList",
      })
    );
    this.$store.dispatch(
      "common/setAllLedgerList",
      JSON.stringify({
        itemCode: "LedgerList",
        JobType:'',
        ShipmentType:'',
        ModuleType:'',
        isLedgerActive:'1',
      })
    );

    // this.$store.dispatch(
    //   "common/setAllLeadClientList",
    //   JSON.stringify({
    //     itemCode: "enq_price_lead_clientList",
    //   })
    // );
    // Sea Section End

    this.$store.dispatch(
      "common/setAllContainerTypeList",
      JSON.stringify({
        itemCode: "ContainerTypeList",
      })
    );
    this.$store.dispatch(
      "common/setAllUnitList",
      JSON.stringify({
        itemCode: "UnitList",
      })
    );
    this.$store.dispatch(
      "common/setAllCurrencyList",
      JSON.stringify({ Currency: "Currency_DropDown" })
    );

    let payload = {
      Currency: "Currency_DropDown",
    };
    this.$store.dispatch("common/setAllCurrencyList", JSON.stringify(payload));

    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEnginePODDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEnginePODDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEnginePOLDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEnginePOLDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineFPODDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineFPODDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEnginePORDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEnginePORDDList",
      })
    );

    // Import DropDown Start
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPODDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineIMPPODDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPOLDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineIMPPOLDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineIMPFPODDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineIMPFPODDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPORDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineIMPPORDDList",
      })
    );
    // Import DropDown End
    if (globalPermissionStatus("Enq. For Pricing")) {
      this.$store.dispatch("setCurrentRoute", "/enqPrice/enqPriceList");
      this.getClientLeadList();
      if (
        this.$sessionsStorage.get("edit_enq_price_id") != undefined &&
        this.$sessionsStorage.get("edit_enq_price_id") != null &&
        this.$sessionsStorage.get("edit_enq_price_id") != ""
      ) {
        // alert(this.$sessionsStorage.get("edit_enq_price_id"))
        this.getSingleEnqPricing(this.$sessionsStorage.get("edit_enq_price_id"));
        this.getSinglePricing(this.$sessionsStorage.get("edit_enq_price_id"));
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      // Price Engine Section Start
      validatePriceEngine: true,
      PricingEngineCountArr: [
        {
          enq_price_engine_id: "",
          fk_enq_price_engine_id: "",
          fk_price_id: "",
          fk_enq_price_id: "",
          enq_price_engine_quotation_id: "",
          commodity_type: "",
          // fk_por_id: "",
          fk_pol_id: "",
          fk_pod_id: "",
          // fk_fpod_id: "",
          fk_currency_id: "1",
          fk_cont_type_id: "1",
          of_twenty_gp: "",
          twenty_gp_add_charg: "",
          tot_twenty_gp: "",
          // of_fourty_hc: "",
          // fourty_hc_add_charg: "",
          // tot_fourty_hc: "",
          free_time: "",
          validity_date: "",
          handover: "",
          expire_status: "",

          commodity_type_err: "",
          // fk_por_id_err: "",
          fk_pol_id_err: "",
          fk_pod_id_err: "",
          // fk_fpod_id_err: "",
          fk_currency_id_err: "",
          fk_cont_type_id_err: "",
          of_twenty_gp_err: "",
          twenty_gp_add_charg_err: "",
          // tot_twenty_gp_err: "",
          // of_fourty_hc_err: "",
          // fourty_hc_add_charg_err: "",
          tot_fourty_hc_err: "",
          free_time_err: "",
          validity_date_err: "",
          validity_date_expire_status_err: "",
          handover_err: "",
        },
      ],
      handOverList: [
        {
          handText: "HANDOVER",
          handVal: "HANDOVER",
        },
        {
          handText: "GATE IN",
          handVal: "GATE IN",
        },
        {
          handText: "SAILING",
          handVal: "SAILING",
        },
      ],
      commodityTypeName: [
        {
          commodityTypeVal: "Hazardous",
          commodityTypeText: "HAZ",
        },
        {
          commodityTypeVal: "Reefer",
          commodityTypeText: "REEFER",
        },
        {
          commodityTypeVal: "Others",
          commodityTypeText: "GENERAL",
        },
      ],
      // Price Engine Section End
      validateCONC: true,
      enqPrice_EditFlag: false,
      CONTAINERCOUNTArr: [
        {
          cont_type: "",
          Vessle: "",
          rate_validity_date: "",
          buyingRate: "",

          cont_type_err: "",
          Vessle_err: "",
          rate_validity_date_err: "",
          buyingRate_err: "",
        },
      ],

      // master_pricing_qutation
      getPortDischargeList: [],
      selectDateFormat,
      transhipmentList: [
        { payVal: "Yes", payText: "Yes", notEnabled: false },
        { payVal: "No", payText: "No", notEnabled: false },
      ],
      pricingForm: {
        fk_enq_price_id: this.$sessionsStorage.get("edit_enq_price_id"),
        price_id: "",
        validityDate: "",
        fk_shipping_id: "",
        fk_airline_id: "",
        quotationTill: "",
        quotation_remark: "",
        transitTime: "",
        ParticularType: "",
        fk_ledger_id: "",
        fk_container_type_id: "",
        cargoReceived: "",
        lclGrossWgt: "",
        noOfPkg: "",
        lclNetWgt: "",
        buyingRate: "",
        sellingRate: "",
        fk_currency_id: "",
        fk_unit_id: "",
        terms: "",
        transhipment: "No",
        fk_pod_id: "",
        fk_airportDestination_id: "",
        createdBy: "",
        created_at: "",
        containertype_json: [],
        priceengine_json: [],

        fk_pol_id: "",
        fk_pod_id: "",
        fk_por_id: "",
        commodity_type: "",
      },
      errorList: {
        // quotationTill: "",
        validityDate: "",
        // transitTime: "",
        ParticularType: "",
        fk_ledger_id: "",
        buyingRate: "",
        // sellingRate: "",
        fk_currency_id: "",
        fk_unit_id: "",
        // terms: "",
      },
      pricingFormError: [
        // "Please Select Validity Till",
        "Please Select Validity Date ",
        // "Please Select Transit Time ",
        "Please Select Particular Type ",
        "Please Select Particular",
        "Please Enter Buying Rate",
        // "Please Enter Selling Rate",
        "Please Select Currency ",
        "Please Select Units",
        // "Please Select Terms",
      ],
      cargoReceivedList: [
        {
          type: "Airport",
          val: "1",
        },
        {
          type: "Warehouse",
          val: "2",
        },
      ],

      termList: [
        {
          tV: "Collect",
          tT: "Collect",
        },
        {
          tV: "Prepaid",
          tT: "Prepaid",
        },
      ],

      confirm: {
        title: "Confirmation..!",
        contentHtml: "Data",
        ok: "Send",
        cancel: "Cancel",
      },
      vertical: "bottom",
      horizontal: "center",
      duration: 1700,

      isLoading: false,
      docURL: URL_BASE_DOC,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      qTillList: [
        {
          qV: "1",
          qT: "Validity till Handover",
        },
        {
          qV: "2",
          qT: "Validity till Sailing",
        },
      ],
      ParticularTypeList: [
        {
          PTV: "Ocean Freight",
          PTT: "Ocean Freight",
        },
        {
          PTV: "Local Charges",
          PTT: "Local Charges",
        },
      ],
      enquiryArry: {},
      singlePricingList: [],
      EnqContainerTypeList: [],
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    MultiSelect,
    CustomLoader,
  },

  computed: {
    buttonDisable() {
      return this.mainModal.sendHODApproveFF == "1" ? false : true;
    },
    locationList() {
      return this.getlocationListData;
    },
    IcdPOrtListNew() {
      return this.IcdPOrtList;
    },
    PortDischargeList() {
      return this.getPortDischargeList;
    },
    allLocationList() {
      return this.getAlllocationListData;
    },
    allLocationListFactory() {
      return this.getAlllocationListDataFactory;
    },
    PortList() {
      return this.getPortData;
    },
  },
  watch: {},

  methods: {
    // Price Engine Section Start
    CheckValueNumbers(item, arr) {
      if (!isNaN(item)) {
        if (Number.isInteger(item)) {
        }
      } else {
        this.alert.content = "Please Enter Only Integer and Decimal Values";
        this.$refs["addPop"].open();
      }
    },
    handleWheel(event) {
      // Prevent scrolling while the input is focused
      if (document.activeElement === event.target) {
        event.preventDefault();
      }
    },
    addPricingEngineCount() {
      let obj = {
        enq_price_engine_id: "",
        fk_price_id: "",
        fk_enq_price_id: "",
        fk_enq_price_engine_id: "",
        enq_price_engine_quotation_id: "",
        commodity_type: "",
        // fk_por_id: "",
        fk_pol_id: "",
        fk_pod_id: "",
        // fk_fpod_id: "",
        fk_currency_id: "1",
        fk_cont_type_id: "1",
        of_twenty_gp: "",
        twenty_gp_add_charg: "",
        tot_twenty_gp: "",
        // of_fourty_hc: "",
        // fourty_hc_add_charg: "",
        // tot_fourty_hc: "",
        free_time: "",
        validity_date: "",
        handover: "",
        expire_status: "",

        commodity_type_err: "",
        // fk_por_id_err: "",
        fk_pol_id_err: "",
        fk_pod_id_err: "",
        // fk_fpod_id_err: "",
        fk_currency_id_err: "",
        fk_cont_type_id_err: "",
        of_twenty_gp_err: "",
        twenty_gp_add_charg_err: "",
        tot_twenty_gp_err: "",
        // of_fourty_hc_err: "",
        // fourty_hc_add_charg_err: "",
        // tot_fourty_hc_err: "",
        free_time_err: "",
        validity_date_err: "",
        validity_date_expire_status_err: "",
        handover_err: "",
        is_new: 1,
        pre_validityDate: "",
      };
      this.PricingEngineCountArr.push(obj);
      this.checkValidityStatus(this.PricingEngineCountArr);
    },
    removePricingEngineCount(index) {
      this.PricingEngineCountArr.splice(index, 1);
      this.TotalAMT();
    },
    TotalAMT(itm, idx) {
      let TotAMT20 = 0;
      let amount20 = 0;
      let amount120 = 0;
      // 20 GP
      if (isNaN(itm.of_twenty_gp) || itm.of_twenty_gp == "" || itm.of_twenty_gp == 0) {
        amount20 = 0;
      } else {
        amount20 = itm.of_twenty_gp;
      }

      if (
        isNaN(itm.twenty_gp_add_charg) ||
        itm.twenty_gp_add_charg == "" ||
        itm.twenty_gp_add_charg == 0
      ) {
        amount120 = 0;
      } else {
        amount120 = itm.twenty_gp_add_charg;
      }

      if (TotAMT20 == 0) {
        TotAMT20 = parseFloat(amount20) + parseFloat(amount120);
      } else {
        TotAMT20 = parseFloat(TotAMT20) + parseFloat(amount20) + parseFloat(amount120);
      }
      itm.tot_twenty_gp = TotAMT20;
    },
    validatePriceEngineDetail() {
      let validate_new = true;
      let errCount = 0;

      let MainARR = this.PricingEngineCountArr;
      for (let j = 0; j < MainARR.length; j++) {
        if (MainARR[j].commodity_type == "") {
          this.PricingEngineCountArr[j].commodity_type_err =
            "Commodity " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].commodity_type_err = "";
          validate_new = true;
        }
        // if (MainARR[j].fk_por_id == "") {
        //   this.PricingEngineCountArr[j].fk_por_id_err =
        //     "POR " + parseInt(j + 1) + " Field is Required";
        //   validate_new = false;
        //   ++errCount;
        // } else {
        //   this.PricingEngineCountArr[j].fk_por_id_err = "";
        //   validate_new = true;
        // }

        if (MainARR[j].fk_pol_id == "") {
          this.PricingEngineCountArr[j].fk_pol_id_err =
            "POL " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].fk_pol_id_err = "";
          validate_new = true;
        }

        if (MainARR[j].fk_pod_id == "") {
          this.PricingEngineCountArr[j].fk_pod_id_err =
            "POD " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].fk_pod_id_err = "";
          validate_new = true;
        }

        // if (MainARR[j].fk_fpod_id == "") {
        //   this.PricingEngineCountArr[j].fk_fpod_id_err =
        //     "FPOD " + parseInt(j + 1) + " Field is Required";
        //   validate_new = false;
        //   ++errCount;
        // } else {
        //   this.PricingEngineCountArr[j].fk_fpod_id_err = "";
        //   validate_new = true;
        // }

        if (MainARR[j].fk_currency_id == "") {
          this.PricingEngineCountArr[j].fk_currency_id_err =
            "Currency " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].fk_currency_id_err = "";
          validate_new = true;
        }

        if (MainARR[j].fk_cont_type_id == "") {
          this.PricingEngineCountArr[j].fk_cont_type_id_err =
            "Container Type " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].fk_cont_type_id_err = "";
          validate_new = true;
        }

        if (MainARR[j].of_twenty_gp == "") {
          this.PricingEngineCountArr[j].of_twenty_gp_err =
            "OF-20 GP " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].of_twenty_gp_err = "";
          validate_new = true;
        }

        if (MainARR[j].twenty_gp_add_charg == "") {
          this.PricingEngineCountArr[j].twenty_gp_add_charg_err =
            "Add Charges 20-GP " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].twenty_gp_add_charg_err = "";
          validate_new = true;
        }

        if (MainARR[j].tot_twenty_gp == "") {
          this.PricingEngineCountArr[j].tot_twenty_gp_err =
            "Total 20-GP " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].tot_twenty_gp_err = "";
          validate_new = true;
        }

        // if (MainARR[j].of_fourty_hc == "") {
        //   this.PricingEngineCountArr[j].of_fourty_hc_err =
        //     "OF-40 HC " + parseInt(j + 1) + " Field is Required";
        //   validate_new = false;
        //   ++errCount;
        // } else {
        //   this.PricingEngineCountArr[j].of_fourty_hc_err = "";
        //   validate_new = true;
        // }

        // if (MainARR[j].fourty_hc_add_charg == "") {
        //   this.PricingEngineCountArr[j].fourty_hc_add_charg_err =
        //     "Add Charges 40-HC " + parseInt(j + 1) + " Field is Required";
        //   validate_new = false;
        //   ++errCount;
        // } else {
        //   this.PricingEngineCountArr[j].fourty_hc_add_charg_err = "";
        //   validate_new = true;
        // }

        // if (MainARR[j].tot_fourty_hc == "") {
        //   this.PricingEngineCountArr[j].tot_fourty_hc_err =
        //     "Total 40-HC " + parseInt(j + 1) + " Field is Required";
        //   validate_new = false;
        //   ++errCount;
        // } else {
        //   this.PricingEngineCountArr[j].tot_fourty_hc_err = "";
        //   validate_new = true;
        // }

        if (MainARR[j].free_time == "") {
          this.PricingEngineCountArr[j].free_time_err =
            "Free Time " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].free_time_err = "";
          validate_new = true;
        }

        if (MainARR[j].validity_date == "") {
          this.PricingEngineCountArr[j].validity_date_err =
            "Validity Date " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].validity_date_err = "";
          validate_new = true;
        }
        if (MainARR[j].is_new == 1) {
          if (MainARR[j].expire_status == "Expired") {
            this.PricingEngineCountArr[j].validity_date_expire_status_err =
              "Your Validity Date " + parseInt(j + 1) + " Expired Choose Another Date";
            this.alert.content =
              "Your Validity Date " + parseInt(j + 1) + " Expired Choose Another Date";
            this.$refs["addPop"].open();
            validate_new = false;
            ++errCount;
          } else {
            this.PricingEngineCountArr[j].validity_date_expire_status_err = "";
            validate_new = true;
          }
        }
        if (MainARR[j].handover == "") {
          this.PricingEngineCountArr[j].handover_err =
            "Handover " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].handover_err = "";
          validate_new = true;
        }
      }
      // alert(errCount);
      if (errCount > 0) {
        this.validatePriceEngine = false;
      } else {
        this.validatePriceEngine = true;
      }
    },
    getSlinePriceEngineData() {
      if (
        this.pricingForm.fk_enq_price_id &&
        this.pricingForm.fk_shipping_id &&
        this.pricingForm.fk_pod_id &&
        this.pricingForm.fk_pol_id &&
        this.pricingForm.commodity_type
      ) {
        this.PricingEngineCountArr = [];
        this.isLoading = true;
        let payload = {
          itemCode: "getSlinePriceEngineData",
          fk_sline_id: this.pricingForm.fk_shipping_id,
          fk_pod_id: this.pricingForm.fk_pod_id,
          fk_pol_id: this.pricingForm.fk_pol_id,
          commodity_type: this.pricingForm.commodity_type,
        };

        LeadService.getAllEnqPricingList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              if (data.getSlineBaseEnqPriceEngineList.length > 0) {
                this.PricingEngineCountArr = data.getSlineBaseEnqPriceEngineList;
                this.PricingEngineCountArr.map((engine) => {
                  engine.is_new = 2;
                  engine.pre_validityDate = engine.validity_date;
                });
                this.checkValidityStatus(this.PricingEngineCountArr);
              } else {
                let obj = {
                  enq_price_engine_id: "",
                  fk_price_id: "",
                  fk_enq_price_id: "",
                  fk_enq_price_engine_id: "",
                  enq_price_engine_quotation_id: "",
                  commodity_type: "",
                  // fk_por_id: "",
                  fk_pol_id: "",
                  fk_pod_id: "",
                  // fk_fpod_id: "",
                  fk_currency_id: "1",
                  fk_cont_type_id: "1",
                  of_twenty_gp: "",
                  twenty_gp_add_charg: "",
                  tot_twenty_gp: "",
                  // of_fourty_hc: "",
                  // fourty_hc_add_charg: "",
                  // tot_fourty_hc: "",
                  free_time: "",
                  validity_date: "",
                  handover: "",
                  expire_status: "",

                  commodity_type_err: "",
                  // fk_por_id_err: "",
                  fk_pol_id_err: "",
                  fk_pod_id_err: "",
                  // fk_fpod_id_err: "",
                  fk_currency_id_err: "",
                  fk_cont_type_id_err: "",
                  of_twenty_gp_err: "",
                  twenty_gp_add_charg_err: "",
                  tot_twenty_gp_err: "",
                  // of_fourty_hc_err: "",
                  // fourty_hc_add_charg_err: "",
                  // tot_fourty_hc_err: "",
                  free_time_err: "",
                  validity_date_err: "",
                  validity_date_expire_status_err: "",
                  handover_err: "",
                  is_new: 1,
                };
                this.PricingEngineCountArr.push(obj);
                this.checkValidityStatus(this.PricingEngineCountArr);
              }
              console.log(
                " Single SLine Base ENquiry Price Engine List response=>",
                data
              );
            }

            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on Single Lead Error: ", error);
          });
      } else {
      }
    },

    checkValidityStatus(pricingEngines) {
      const currentDate = new Date(); // Current date with time component
      const today = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate()
      ); // Get only the date part without time

      return pricingEngines.map((engine) => {
        engine.expire_status = "";

        if (engine.is_new === 2) {
          const validityDate = new Date(engine.validity_date);

          if (validityDate < today) {
            engine.expire_status = "Expired";
          } else {
            engine.expire_status = "Active";
          }
        } else {
          engine.expire_status = "Active";
        }
      });
    },
    // Price Engine Section End

    addContainerCount() {
      let obj = {
        cont_type: "",
        Vessle: "",
        rate_validity_date: "",
        buyingRate: "",

        cont_type_err: "",
        Vessle_err: "",
        rate_validity_date_err: "",
        buyingRate_err: "",
      };
      this.CONTAINERCOUNTArr.push(obj);
    },
    removeContainerCount(index) {
      this.CONTAINERCOUNTArr.splice(index, 1);
    },
    validateCONCDetail() {
      let validate_new = true;
      let errCount = 0;

      let MainARR = this.CONTAINERCOUNTArr;
      for (let j = 0; j < MainARR.length; j++) {
        if (MainARR[j].cont_type == "") {
          this.CONTAINERCOUNTArr[j].cont_type_err =
            "Container Type " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.CONTAINERCOUNTArr[j].cont_type_err = "";
          validate_new = true;
        }

        if (MainARR[j].cont_count == "") {
          this.CONTAINERCOUNTArr[j].cont_count_err =
            "Container Count " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.CONTAINERCOUNTArr[j].cont_count_err = "";
          validate_new = true;
        }
      }
      // alert(errCount);
      if (errCount > 0) {
        this.validateCONC = false;
      } else {
        this.validateCONC = true;
      }
    },
    sendCloseEnqPriceForm(singlePricingList, enquiryArry) {
      // console.log("singlePricingList=>",singlePricingList);return false;
      if (enquiryArry.enq_price_id) {
        this.isLoading = true;
        let payload = {
          itemCode: "Send_CloseEnqPrice_Mail",
          pricingForm: singlePricingList,
          enq_details: enquiryArry,
        };
        payload = JSON.stringify(payload);
        if (this.validate != false) {
          LeadService.getAllEnqPricingList(payload)
            .then((response) => {
              const { data, status, statusText } = response;
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.getSinglePricing(this.$sessionsStorage.get("edit_enq_price_id"));
              this.ClearPricingDetails("clearSingle");

              this.isLoading = false;
              this.$refs["addPop"].open();
            })
            .catch((error) => {
              console.log("Catch on Proforma Error: ", error);
            });
        }
      }
    },
    TranshipmentVal() {
      console.log(this.pricingForm.transhipment);
    },
    validatePricing() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (
          this.pricingForm[x] == "" ||
          this.pricingForm[x] == undefined ||
          this.pricingForm[x] == null
        ) {
          this.errorList[x] = this.pricingFormError[index];
          validate_new = false;
        }
      });

      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },
    addPriceForm() {
      this.pricingForm.TypeofAdd = "Pricing Master Add";

      if (this.enquiryArry.shipment_type == "Air") {
        if (
          this.pricingForm.fk_airline_id == "" ||
          this.pricingForm.fk_airline_id == undefined ||
          this.pricingForm.fk_airline_id == null ||
          this.pricingForm.fk_airline_id == "undefined" ||
          this.pricingForm.fk_airline_id == "null"
        ) {
          this.alert.content = "Please Enter Air Line (Prefered)";
          this.$refs["addPop"].open();
          return false;
        }
      } else if (this.enquiryArry.shipment_type == "Sea") {
        if (
          this.pricingForm.fk_shipping_id == "" ||
          this.pricingForm.fk_shipping_id == undefined ||
          this.pricingForm.fk_shipping_id == null ||
          this.pricingForm.fk_shipping_id == "undefined" ||
          this.pricingForm.fk_shipping_id == "null"
        ) {
          this.alert.content = "Please Enter Shipping Line (Prefered)";
          this.$refs["addPop"].open();
          return false;
        }
      }

      this.validatePricing();

      if (
        this.pricingForm.fk_enq_price_id &&
        this.pricingForm.fk_shipping_id &&
        this.pricingForm.fk_pod_id &&
        this.pricingForm.fk_pol_id &&
        this.pricingForm.commodity_type &&
        this.PricingEngineCountArr.length > 0
      ) {
        this.validatePriceEngineDetail();
      }
      if (this.validate == false || this.validatePriceEngine == false) return false;
      this.isLoading = true;
      this.CONTAINERCOUNTArr.forEach((val, ind) => {
        this.$store.getters["common/getAllContainerTypeList"].forEach((val2, ind1) => {
          if (val.cont_type === val2.containerTypeId) {
            val.cont_type_name = val2.containerType;
          }
        });
      });
      this.pricingForm.containertype_json = JSON.stringify(this.CONTAINERCOUNTArr);

      if (this.PricingEngineCountArr.length > 0) {
        this.PricingEngineCountArr.forEach((val, ind) => {
          // this.$store.getters["enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList"].forEach((val1, ind1) => {
          //   if (val.fk_por_id === val1.pickupId) {
          //     val.por_name = val2.pickupLocation;
          //   }
          // });

          this.$store.getters[
            "enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList"
          ].forEach((val2, ind12) => {
            if (val.fk_pol_id === val2.pickupId) {
              val.pol_name = val2.pickupLocation;
            }
          });

          this.$store.getters[
            "enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList"
          ].forEach((val3, ind3) => {
            if (val.fk_pod_id === val3.pickupId) {
              val.pod_name = val3.pickupLocation;
            }
          });

          // this.$store.getters[
          //   "enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList"
          // ].forEach((val5, ind5) => {
          //   if (val.fk_fpod_id === val5.pickupId) {
          //     val.fpod_name = val5.pickupLocation;
          //   }
          // });

          this.$store.getters["common/getAllCurrencyList"].forEach((val4, ind4) => {
            if (val.fk_currency_id === val4.currency_id) {
              val.currency_name = val4.currencyCode;
            }
          });

          this.$store.getters["common/getAllContainerTypeList"].forEach((val5, ind5) => {
            if (val.fk_cont_type_id === val5.containerTypeId) {
              val.cont_type = val5.containerType;
            }
          });
        });
        this.pricingForm.priceengine_json = JSON.stringify(this.PricingEngineCountArr);
      }
      let payload = {
        itemCode: "add_price_details",
        pricingForm: this.pricingForm,
        PricingEngineCountArr: this.PricingEngineCountArr,
      };
      console.log("payload=>", payload);
      // return false;
      payload = JSON.stringify(payload);
      if (this.validate != false) {
        LeadService.getAllEnqPricingList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log("Priyanshu Singh response=>", response);
            if (data.price_id != "" && data.price_id != undefined) {
              this.getSinglePricing(this.$sessionsStorage.get("edit_enq_price_id"));
              this.ClearPricingDetails("clearSingle");
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
            this.getSinglePricing(this.$sessionsStorage.get("edit_enq_price_id"));
            if (data.flag == true) {
              this.$router.push({
                path: "/pricing/upsertPrice",
              });
            }
            this.ClearPricingDetails();
          })
          .catch((error) => {
            console.log("Catch on addPriceForm Error: ", error);
          });
      }
    },
    getSingleEnqPricing(id) {
      this.isLoading = true;
      let payload = {
        itemCode: "Single_enq_price",
        enq_price_id: id,
      };
      LeadService.getAllEnqPricingList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.enquiryArry = data.singleEnqPricing;
            this.pricingForm.fk_pol_id = this.enquiryArry.fk_pol_id;
            this.pricingForm.fk_pod_id = this.enquiryArry.fk_pod_id;
            console.log(" Single Lead response=>", this.enquiryArry);
        
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Single Lead Error: ", error);
        });
    },
    getSinglePricing(id) {
      this.isLoading = true;
      let payload = {
        itemCode: "Single_price_list_Quataion",
        fk_enq_price_id: id,
      };
      LeadService.getAllEnqPricingList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            // this.setPricingDetails(
            //   data.singlePricing,
            //   id
            // );
            this.singlePricingList = data.singlePricing;
            if (data.ContainerTypeList.length > 0) {
              this.EnqContainerTypeList = data.ContainerTypeList;
            }
            // this.enquiryArry = data.singleEnqPricing;
            console.log(" Single Lead response=>", this.singlePricingList);
          }
          this.getSingleLastPricing(id);
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Single Lead Error: ", error);
        });
    },
    getSingleLastPricing(id) {
      this.isLoading = true;
      let payload = {
        itemCode: "Single_price_listLast_Quataion",
        fk_enq_price_id: id,
      };
      LeadService.getAllEnqPricingList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            // this.setPricingDetails(
            //   data.singlePricing,
            //   id
            // );

            // this.pricingForm.fk_pol_id = data.singlePricingLast.enq_fk_pol_id;
            // this.pricingForm.fk_pod_id = data.singlePricingLast.enq_fk_pod_id;
            this.pricingForm.fk_por_id = data.singlePricingLast.enq_fk_por_id;
            // this.pricingForm.commodity_type = data.singlePricingLast.enq_commodity_type;
            console.log("Priyanshu SIngh=>", data.singlePricingLast);

            this.pricingForm.fk_container_type_id =
              data.singlePricingLast.fk_container_type_id;
            this.pricingForm.validityDate = data.singlePricingLast.validityDate;
            this.pricingForm.fk_shipping_id = data.singlePricingLast.fk_shipping_id;
            this.pricingForm.fk_airline_id = data.singlePricingLast.fk_airline_id;
            this.pricingForm.fk_currency_id = data.singlePricingLast.fk_currency_id;
            this.pricingForm.fk_unit_id = data.singlePricingLast.fk_unit_id;
            this.pricingForm.transhipment = data.singlePricingLast.transhipment;
            // this.pricingForm.fk_pod_id = data.singlePricingLast.fk_pod_id;
            this.pricingForm.fk_airportDestination_id =
              data.singlePricingLast.fk_airportDestination_id;
            this.pricingForm.quotation_remark = data.singlePricingLast.quotation_remark;
            this.pricingForm.quotationTill = data.singlePricingLast.quotationTill;
            this.pricingForm.transitTime = data.singlePricingLast.transitTime;
            this.pricingForm.ParticularType = data.singlePricingLast.ParticularType;
            this.pricingForm.createdBy = data.singlePricingLast.createdBy;
            this.pricingForm.created_at = data.singlePricingLast.created_at;
            console.log(" Single Lead response=>", this.singlePricingList);
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Single Lead Error: ", error);
        });
    },
    ClearPricingDetails(type) {
      if (type == "clearAll") {
        this.pricingForm = {
          fk_enq_price_id: this.$sessionsStorage.get("edit_enq_price_id"),
          price_id: "",
          validityDate: "",
          fk_shipping_id: "",
          fk_airline_id: "",
          quotationTill: "",
          quotation_remark: "",
          transitTime: "",
          ParticularType: "",
          fk_ledger_id: "",
          fk_container_type_id: "",
          cargoReceived: "",
          lclGrossWgt: "",
          noOfPkg: "",
          lclNetWgt: "",
          buyingRate: "",
          sellingRate: "",
          fk_currency_id: "",
          fk_unit_id: "",
          terms: "",
          transhipment: "",
          fk_pod_id: "",
          fk_airportDestination_id: "",
          containertype_json: [],
          priceengine_json: [],

          fk_pol_id: "",
          fk_pod_id: "",
          fk_por_id: "",
          commodity_type: "",
        };
      } else {
        this.pricingForm = {
          fk_enq_price_id: this.$sessionsStorage.get("edit_enq_price_id"),
          price_id: "",
          // validityDate: "",
          // fk_shipping_id: "",
          // fk_airline_id: "",
          // quotationTill: "",
          // quotation_remark: "",
          // transitTime: "",
          // ParticularType: "",
          fk_ledger_id: "",
          // fk_container_type_id: "",
          cargoReceived: "",
          lclGrossWgt: "",
          noOfPkg: "",
          lclNetWgt: "",
          buyingRate: "",
          sellingRate: "",
          // fk_currency_id: "",
          // fk_unit_id: "",
          terms: "",
          // transhipment: "",
          // fk_pod_id: "",
          // fk_airportDestination_id: "",
          containertype_json: [],
          priceengine_json: [],

          fk_pol_id: "",
          fk_pod_id: "",
          fk_por_id: "",
          commodity_type: "",
        };
      }
    },
    editPrice(item) {
      this.pricingForm = {
        fk_enq_price_id: this.$sessionsStorage.get("edit_enq_price_id"),
        price_id: item.price_id,
        validityDate: item.validityDate,
        fk_shipping_id: item.fk_shipping_id,
        fk_airline_id: item.fk_airline_id,
        quotationTill: item.quotationTill,

        quotation_remark: item.quotation_remark,
        transitTime: item.transitTime,
        ParticularType: item.ParticularType,
        fk_ledger_id: item.fk_ledger_id,
        fk_container_type_id: item.fk_container_type_id,
        cargoReceived: item.cargoReceived,
        lclGrossWgt: item.lclGrossWgt,
        noOfPkg: item.noOfPkg,
        lclNetWgt: item.lclNetWgt,

        buyingRate: item.buyingRate,
        sellingRate: item.sellingRate,
        fk_currency_id: item.fk_currency_id,
        fk_unit_id: item.fk_unit_id,
        terms: item.terms,
        transhipment: item.transhipment,
        fk_pod_id: item.fk_pod_id,
        fk_airportDestination_id: item.fk_airportDestination_id,
        containertype_json: [],
        priceengine_json: [],
      };
      if (
        this.$sessionsStorage.get("designation") == "Admin" &&
        this.$sessionsStorage.get("nameUser") == "Bhavneesh"
      ) {
        this.enqPrice_EditFlag = false;
      } else {
        this.enqPrice_EditFlag = true;
      }
      this.pricingForm.priceengine_json = [];
      let containertype_json = JSON.parse(item.containertype_json);
      let priceengine_json = JSON.parse(item.priceengine_json);
      this.pricingForm.priceengine_json = priceengine_json;
      this.CONTAINERCOUNTArr = [];
      this.PricingEngineCountArr = [];
      if (containertype_json.length > 0) {
        containertype_json.forEach((val, ind) => {
          let obj = {
            cont_type: val.cont_type,
            Vessle: val.Vessle,
            rate_validity_date: val.rate_validity_date,
            buyingRate: val.buyingRate,
            cont_type_name: val.cont_type_name,

            cont_type_err: "",
            Vessle_err: "",
            rate_validity_date_err: "",
            buyingRate_err: "",
          };
          this.CONTAINERCOUNTArr.push(obj);
        });
      }

      if (priceengine_json.length > 0) {
        priceengine_json.forEach((val, ind) => {
          let obj = {
            enq_price_engine_id: val.enq_price_engine_id,
            fk_enq_price_engine_id: val.fk_enq_price_engine_id,
            fk_price_id: val.fk_price_id,
            fk_enq_price_id: val.fk_enq_price_id,
            enq_price_engine_quotation_id: val.enq_price_engine_quotation_id,
            commodity_type: val.commodity_type,
            // fk_por_id: val.fk_por_id,
            fk_pol_id: val.fk_pol_id,
            fk_pod_id: val.fk_pod_id,
            // fk_fpod_id: val.fk_fpod_id,
            fk_currency_id: val.fk_currency_id,
            fk_cont_type_id: val.fk_cont_type_id,
            of_twenty_gp: val.of_twenty_gp,
            twenty_gp_add_charg: val.twenty_gp_add_charg,
            tot_twenty_gp: val.tot_twenty_gp,
            // of_fourty_hc: val.of_fourty_hc,
            // fourty_hc_add_charg: val.fourty_hc_add_charg,
            // tot_fourty_hc: val.tot_fourty_hc,
            free_time: val.free_time,
            validity_date: val.validity_date,
            handover: val.handover,
            expire_status: "",

            commodity_type_err: val.commodity_type_err,
            // fk_por_id_err: val.fk_por_id_err,
            fk_pol_id_err: val.fk_pol_id_err,
            fk_pod_id_err: val.fk_pod_id_err,
            // fk_fpod_id_err: val.fk_fpod_id_err,
            fk_currency_id_err: val.fk_currency_id_err,
            fk_cont_type_id_err: val.fk_cont_type_id_err,
            of_twenty_gp_err: val.of_twenty_gp_err,
            twenty_gp_add_charg_err: val.twenty_gp_add_charg_err,
            tot_twenty_gp_err: val.tot_twenty_gp_err,
            // of_fourty_hc_err: val.of_fourty_hc_err,
            // fourty_hc_add_charg_err: val.fourty_hc_add_charg_err,
            // tot_fourty_hc_err: val.tot_fourty_hc_err,
            free_time_err: val.free_time_err,
            validity_date_err: val.validity_date_err,
            validity_date_expire_status_err: val.validity_date_expire_status_err,
            handover_err: val.handover_err,
            is_new: 2,
          };
          this.PricingEngineCountArr.push(obj);
          this.checkValidityStatus(this.PricingEngineCountArr);
        });
      }
    },
    setPricingDetails(item, enq_price_id) {
      if (enq_price_id != undefined && enq_price_id != null && enq_price_id != "") {
        if (
          this.$sessionsStorage.get("designation") == "Admin" &&
          this.$sessionsStorage.get("nameUser") == "Bhavneesh"
        ) {
          this.enqPrice_EditFlag = false;
        } else {
          this.enqPrice_EditFlag = true;
        }
        let pricingForm = item;
        this.pricingForm.containertype_json = [];
        this.pricingForm.priceengine_json = [];
        console.log("pricingForm", pricingForm);

        this.pricingForm = {
          fk_enq_price_id: pricingForm.enq_price_id,
          price_id: pricingForm.price_id,
          validityDate: pricingForm.validityDate,
          fk_shipping_id: pricingForm.fk_shipping_id,
          fk_airline_id: pricingForm.fk_airline_id,
          quotationTill: pricingForm.quotationTill,

          quotation_remark: pricingForm.quotation_remark,
          transitTime: pricingForm.transitTime,
          ParticularType: pricingForm.ParticularType,
          fk_ledger_id: pricingForm.fk_ledger_id,
          fk_container_type_id: pricingForm.fk_container_type_id,
          cargoReceived: pricingForm.cargoReceived,
          lclGrossWgt: pricingForm.lclGrossWgt,
          noOfPkg: pricingForm.noOfPkg,
          lclNetWgt: pricingForm.lclNetWgt,

          buyingRate: pricingForm.buyingRate,
          sellingRate: pricingForm.sellingRate,
          fk_currency_id: pricingForm.fk_currency_id,
          fk_unit_id: pricingForm.fk_unit_id,
          terms: pricingForm.terms,
          transhipment: pricingForm.transhipment,
          fk_pod_id: pricingForm.fk_pod_id,
          fk_airportDestination_id: pricingForm.fk_airportDestination_id,

          fk_pol_id: pricingForm.fk_pol_id,
          fk_pod_id: pricingForm.fk_pod_id,
          fk_por_id: pricingForm.fk_por_id,
          commodity_type: pricingForm.commodity_type,
        };
        this.pricingForm.priceengine_json = [];
        let containertype_json = JSON.parse(pricingForm.containertype_json);
        let priceengine_json = JSON.parse(item.priceengine_json);
        this.pricingForm.priceengine_json = priceengine_json;
        this.CONTAINERCOUNTArr = [];
        this.PricingEngineCountArr = [];
        if (containertype_json.length > 0) {
          containertype_json.forEach((val, ind) => {
            let obj = {
              cont_type: val.cont_type,
              Vessle: val.Vessle,
              rate_validity_date: val.rate_validity_date,
              buyingRate: val.buyingRate,
              cont_type_name: val.cont_type_name,

              cont_type_err: "",
              Vessle_err: "",
              rate_validity_date_err: "",
              buyingRate_err: "",
            };
            this.CONTAINERCOUNTArr.push(obj);
          });
        }
        if (priceengine_json.length > 0) {
          priceengine_json.forEach((val, ind) => {
            let obj = {
              enq_price_engine_id: val.enq_price_engine_id,
              fk_enq_price_engine_id: val.fk_enq_price_engine_id,
              fk_price_id: val.fk_price_id,
              fk_enq_price_id: val.fk_enq_price_id,
              enq_price_engine_quotation_id: val.enq_price_engine_quotation_id,
              commodity_type: val.commodity_type,
              // fk_por_id: val.fk_por_id,
              fk_pol_id: val.fk_pol_id,
              fk_pod_id: val.fk_pod_id,
              // fk_fpod_id: val.fk_fpod_id,
              fk_currency_id: val.fk_currency_id,
              fk_cont_type_id: val.fk_cont_type_id,
              of_twenty_gp: val.of_twenty_gp,
              twenty_gp_add_charg: val.twenty_gp_add_charg,
              tot_twenty_gp: val.tot_twenty_gp,
              // of_fourty_hc: val.of_fourty_hc,
              // fourty_hc_add_charg: val.fourty_hc_add_charg,
              // tot_fourty_hc: val.tot_fourty_hc,
              free_time: val.free_time,
              validity_date: val.validity_date,
              handover: val.handover,
              expire_status: "",

              commodity_type_err: val.commodity_type_err,
              // fk_por_id_err: val.fk_por_id_err,
              fk_pol_id_err: val.fk_pol_id_err,
              fk_pod_id_err: val.fk_pod_id_err,
              // fk_fpod_id_err: val.fk_fpod_id_err,
              fk_currency_id_err: val.fk_currency_id_err,
              fk_cont_type_id_err: val.fk_cont_type_id_err,
              of_twenty_gp_err: val.of_twenty_gp_err,
              twenty_gp_add_charg_err: val.twenty_gp_add_charg_err,
              tot_twenty_gp_err: val.tot_twenty_gp_err,
              // of_fourty_hc_err: val.of_fourty_hc_err,
              // fourty_hc_add_charg_err: val.fourty_hc_add_charg_err,
              // tot_fourty_hc_err: val.tot_fourty_hc_err,
              free_time_err: val.free_time_err,
              validity_date_err: val.validity_date_err,
              validity_date_expire_status_err: val.validity_date_expire_status_err,
              handover_err: val.handover_err,
              is_new: 2,
            };
            this.PricingEngineCountArr.push(obj);
            this.checkValidityStatus(this.PricingEngineCountArr);
          });
        }
      } else {
        this.pricingForm = {
          fk_enq_price_id: this.$sessionsStorage.get("edit_enq_price_id"),
          price_id: "",
          validityDate: "",
          fk_shipping_id: "",
          fk_airline_id: "",
          quotationTill: "",
          quotation_remark: "",
          transitTime: "",
          ParticularType: "",
          fk_ledger_id: "",
          fk_container_type_id: "",
          cargoReceived: "",
          lclGrossWgt: "",
          noOfPkg: "",
          lclNetWgt: "",
          buyingRate: "",
          sellingRate: "",
          fk_currency_id: "",
          fk_unit_id: "",
          terms: "",
          transhipment: "",
          fk_pod_id: "",
          fk_airportDestination_id: "",

          fk_pol_id: "",
          fk_pod_id: "",
          fk_por_id: "",
          commodity_type: "",
        };
      }
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    async getClientLeadList() {
      this.clientLeadList = [];
      let payload = {
        itemCode: "enq_price_lead_clientList",
      };
      await LeadService.getClientLeadList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          this.clientLeadList = data.LeadClientList;
          console.log("getAllLeadClientList : ", data.LeadClientList);
        })
        .catch((error) => {
          console.log("Catch on getAllLeadClientList Error: ", error);
        });
      this.getPortDischargeList = this.$store.getters[
        "common/getAllLocationDetailsFinalList"
      ];
    },
    goBack() {
      window.history.go(-1);
    },

    Print(item) {
      window.open(`${this.docURL}/FF_QUOTATION_PDF/` + item);
    },
    // By Priyanshu Singh 24/12/2021 Start
    dateDifference(pre_validityDate, current_date) {
      let date1 = new Date(pre_validityDate); //7/13/2010
      let date2 = new Date(current_date); //12/15/2010

      let diffTime = Math.abs(date2 - date1);
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },
    currentDate() {
      var currentDate = new Date();
      var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, "-");
      return currentDateWithFormat;
    },
    convert(str) {
      var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    },
    calculateMinDate() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      // 15th two months prior
      const minDate = new Date(today);
      minDate.setMonth(minDate.getMonth());
      return minDate.setDate(now.getDate());
    },
    QutationValidityhide(pre_validityDate, isHidden) {
      this.dateRestriction(pre_validityDate);
      $("#QutationValidityhide_err").text("");
      let current_date = this.currentDate();
      // current_date = '2022-08-04';
      let date1 = new Date(pre_validityDate); //7/13/2010
      let date2 = new Date(current_date); //12/15/2010
      let days_count = 0;
      if (date2 >= date1) {
        days_count = this.dateDifference(pre_validityDate, current_date);
      } else {
        days_count = 0;
      }
      // alert(days_count);
      // let days_count = 46;
      if (
        this.$sessionsStorage.get("designation") != "Admin" &&
        this.$sessionsStorage.get("nameUser") != "Bhavneesh"
      ) {
        if (days_count > 45) {
          this.isHidden = true;
          this.errorModal.validityDate =
            "Sorry Your Qutation Validity Extends after(45 Days also Expire) You are not allowed";
          $("#QutationValidityhide_err").text(
            "Sorry Your Qutation Validity Extends after(45 Days also Expire) You are not allowed"
          );
          // console.log("Sorry Your Qutation Validity Extends after(45 Days also Expire) You are not allowed");
        } else {
          if (isHidden == false) {
            this.isHidden = true;
          } else if (isHidden == true) {
            this.isHidden = false;
          } else {
            this.isHidden = false;
          }
        }
      } else {
        if (isHidden == false) {
          this.isHidden = true;
        } else if (isHidden == true) {
          this.isHidden = false;
        } else {
          this.isHidden = false;
        }
      }
    },
    validityDateDifference(pre_validityDate, validity_date) {
      if (validity_date) {
        const today = new Date();
        const validityDate = new Date(validity_date);
        validityDate.setHours(0, 0, 0, 0); // Set time to midnight for accurate comparison

        const differenceInTime = validityDate.getTime() - today.getTime();
        const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));

        return differenceInDays;
      } else {
        return null; // Return null if no validity date is selected
      }
    },
    updateValidityDate(item, pre_validityDate, validity_date) {
      let current_date = this.currentDate();
      console.log("current_date=>", current_date);
      console.log("pre_validityDate=>", pre_validityDate);
      console.log("validity_date=>", validityDate);
      let days_count = this.validityDateDifference(
        item.pre_validityDate,
        item.validity_date
      );
      if (item.validity_date && days_count > 0) {
        this.isLoading = true;
        let payload = {
          itemCode: "enq_price_engine_update_validityDate",
          tableName: "enq_price_engine_master",
          tableKeyVal: item.enq_price_engine_id,
          tableKey: "enq_price_engine_id",
          setFieldKeyVal: this.convert(item.validity_date),
          setFieldKey: "validity_date",
          pre_validityDate: item.pre_validityDate,
          changedValues: [item],
        };
        LeadService.getAllEnqPricingList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.isLoading = false;
              this.$refs["addPop"].open();
              this.getSlinePriceEngineData();
            }

            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on Single Lead Error: ", error);
          });
      } else {
        this.alert.content = "Please Enter Validity Date";
        this.$refs["addPop"].open();
      }
    },
    // By Priyanshu Singh 24/12/2021 End
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// pricing.vue?1efafc97